import Add16 from '@carbon/icons-react/es/add/16';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'components/atoms/button';
import { TranslationKey } from 'hooks/use-translation';
import { Loading } from './styles';

interface Props {
  onClick?: () => void;
  route: string;
  isCreating?: boolean;
  translationKey: TranslationKey;
}

export const NewTemplateCta: FC<Props> = ({
  route,
  onClick,
  isCreating,
  children,
  translationKey,
}) => {
  return (
    <Link to={route}>
      {' '}
      <Button
        onClick={onClick}
        icon={isCreating ? <Loading size="small" /> : <Add16 />}
        iconPlacement="right"
        type="primary"
        data-cy={`${translationKey}.create.new`}
      >
        {children}
      </Button>
    </Link>
  );
};
